import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {TOOLTIP_PLACEMENT} from "../../../../core/components/tooltip/tooltip-consts";
import {Trend} from "../../../../core/components/trend/trend";
import {TREND} from "../../../../core/app/consts";
import {Tooltip} from "../../../../core/components/tooltip/tooltip";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";

export class StandingsWidgetCompetitorTrendProps extends BaseProps {
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetCompetitorTrend = observer(({row}: StandingsWidgetCompetitorTrendProps) => {
  const {trend, hasTrend, previousPositionTooltipLabel} = row;

  const tooltipProps = {
    title: previousPositionTooltipLabel,
    placement: TOOLTIP_PLACEMENT.bottom,
    className: classNames(
      styles.competitor_trend,
      {[styles.competitor_trend_up]: trend === TREND.up},
      {[styles.competitor_trend_down]: trend === TREND.down}
    )
  }

  const trendProps = {
    shouldRenderTrend: hasTrend,
    trend,
  }

  return hasTrend ?
    <Tooltip {...tooltipProps}>
      <Trend {...trendProps}/>
    </Tooltip> : null
});
